module.exports = __webpack_public_path__ + "img/AHS-6236_HealthierTogether-color.969693ef.svg";